/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Comment({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/CommentsLogs/Comments/Content/Content/Comment"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let commentValueData = fromData.useDataFormat({ viewPath,
context: 'comment',
format: fromHelpers.getAuthorName,
})
let commentValueValueData = fromData.useDataValue({ viewPath,
context: 'comment',
path: 'value',
})
  return (<React.Fragment
>
<div
  data-testid="Comment.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-3-Z1Yk7NE': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2UserSingleCircle
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 width={32}
 height={32}
/>
<div
  data-testid="Comment.Vertical"
  data-view-path={viewPath}
 style={{'--g-3-Z1Yk7NE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="comment"
 format="helpers.js getAuthorName"
 text={commentValueData}
/>
<div
  data-testid="Comment.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="comment.value"
 text={commentValueValueData}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}